module.exports = __webpack_public_path__ + "img/portrait-042.066ac618.jpg";